export default __webpack_public_path__ + "static/media/github-p-500.61f92450.png";